<template>
  <div v-if="cookies">
    <popup-edit-cookie :cookie="selected" ref="popupEditCookie" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Cookies</h3>
        <p class="mt-5">
          Cookie popup can be configured here as well as description and type of
          individual cookies. Cookies are automatically detected from page
          views.
        </p>
      </vs-col>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        pagination
        search
        v-model="selected"
        max-items="50"
        :data="cookies"
        @selected="$refs.popupEditCookie.show()"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>Vendor</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>Method</vs-th>
          <vs-th>Type</vs-th>
          <vs-th>First seen</vs-th>
          <vs-th>Seen on</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.vendor }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.category }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.method }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.type }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.firstSeenOn | formatDate }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.seenOn.length }} venues
                </p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PopupEditCookie from "./PopupEditCookie.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: { PopupEditCookie },
  data() {
    return {
      // eslint-disable-next-line
      _,
      selected: null, // eslint-disable-line
      removeId: "",
    };
  },
  methods: {
    async confirmDelete(tr) {
      this.removeId = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this cookie?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("cookies/delete", this.removeId);
      this.$vs.loading.close();
    },
    venueName(venueId) {
      if (!this.venues) return "";
      const venue = _.find(this.venues, (e) => e.venueId === venueId);
      return venue ? venue.name : "Not specified";
    },
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues",
      cookies: "cookies/cookies",
      categories: "cookies/categories",
      types: "cookies/types",
      methods: "cookies/methods",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("cookies/getAll");
    this.$vs.loading.close();
  },
};
</script>
